export { StickyFooter, DialogFooter } from './sticky-footer';
